<div class="more-info-container">
    <div class="heading">
        <h1>{{ 'more-info.title' | translate }}</h1>
    </div>
    <div class="more-info">
        <div [innerHTML]="'events.' + eventType + '.full' | translate"></div>
    </div>
</div>